import { getApplicationSettings } from 'owa-application-settings';

export function isPhotoPickerEnabled(): boolean {
    return getApplicationSettings('LivePersonaEditor').enablePhotoPicker;
}
